import { useState } from "react";

const modules = [
  {
    id: 1,
    tag: "Módulo 1",
    name: "Fundamentos do Método CAT",
    desc: "Entenda os pilares que sustentam o método e como aplicar desde o primeiro dia.",
    icon: "ri-book-open-line",
    color: "bg-[#1a1a1a]",
    accent: "text-white/30",
    isNew: true,
    image: "https://readdy.ai/api/search-image?query=ultra%20elegant%20wealthy%20prosperous%20saleswoman%20in%20a%20luxurious%20high-end%20boutique%20wearing%20a%20golden%20couture%20blazer%20with%20diamond%20jewelry%20standing%20confidently%20surrounded%20by%20opulent%20warm%20amber%20golden%20light%20black%20and%20gold%20interior%20sophisticated%20rich%20woman%20successful%20businesswoman%20dark%20background%20deep%20black%20tones%20gold%20accents%20cinematic%20portrait%20editorial%20fashion%20photography&width=600&height=800&seq=mod1-saleswoman-gold-01&orientation=portrait",
  },
  {
    id: 2,
    tag: "Módulo 2",
    name: "Comportamento do Consumidor",
    desc: "Decodifique o que leva o cliente a dizer sim e use isso a seu favor.",
    icon: "ri-user-heart-line",
    color: "bg-[#2c1f14]",
    accent: "text-white/30",
    isNew: true,
    image: "https://readdy.ai/api/search-image?query=affluent%20stylish%20woman%20customer%20shopping%20in%20luxury%20premium%20store%20surrounded%20by%20golden%20warm%20light%20dark%20moody%20atmosphere%20black%20and%20gold%20tones%20premium%20retail%20experience%20elegant%20sophisticated%20cinematic&width=600&height=800&seq=mod2-consumer-gold-01&orientation=portrait",
  },
  {
    id: 3,
    tag: "Módulo 3",
    name: "Técnicas de Abordagem e Conexão",
    desc: "Aprenda a criar rapport instantâneo e transformar cada atendimento em oportunidade.",
    icon: "ri-shake-hands-line",
    color: "bg-[#141a1a]",
    accent: "text-white/30",
    isNew: false,
    image: "https://readdy.ai/api/search-image?query=two%20elegant%20professional%20women%20shaking%20hands%20in%20luxury%20boutique%20confidently%20smiling%20warm%20golden%20ambient%20light%20dark%20sophisticated%20atmosphere%20black%20and%20gold%20palette%20business%20connection%20premium%20sales&width=600&height=800&seq=mod3-connection-gold-01&orientation=portrait",
  },
  {
    id: 4,
    tag: "Módulo 4",
    name: "Vendas pelo WhatsApp Business",
    desc: "Scripts, automações e estratégias para fechar mais vendas pelo app.",
    icon: "ri-whatsapp-line",
    color: "bg-[#0d1a10]",
    accent: "text-white/30",
    isNew: true,
    image: "https://readdy.ai/api/search-image?query=glamorous%20businesswoman%20holding%20gold%20smartphone%20messaging%20on%20phone%20in%20luxury%20dark%20office%20environment%20warm%20golden%20light%20premium%20aesthetic%20black%20background%20gold%20tones%20wealthy%20successful%20sales%20professional&width=600&height=800&seq=mod4-whatsapp-gold-01&orientation=portrait",
  },
  {
    id: 5,
    tag: "Módulo 5",
    name: "IA Aplicada ao Varejo",
    desc: "Use inteligência artificial para escalar atendimentos e multiplicar resultados.",
    icon: "ri-robot-2-line",
    color: "bg-[#1a1025]",
    accent: "text-white/30",
    isNew: true,
    image: "https://readdy.ai/api/search-image?query=futuristic%20elegant%20businesswoman%20interacting%20with%20holographic%20digital%20AI%20interface%20in%20dark%20luxury%20environment%20golden%20light%20particles%20technology%20retail%20innovation%20premium%20black%20and%20gold%20aesthetic%20cinematic&width=600&height=800&seq=mod5-ai-gold-01&orientation=portrait",
  },
  {
    id: 6,
    tag: "Módulo 6",
    name: "Gestão de Equipe de Vendas",
    desc: "Forme, motive e gerencie uma equipe campeã com as ferramentas certas.",
    icon: "ri-team-line",
    color: "bg-[#1a0d0d]",
    accent: "text-white/30",
    isNew: false,
    image: "https://readdy.ai/api/search-image?query=confident%20successful%20female%20team%20leader%20standing%20with%20her%20elegant%20sales%20team%20in%20luxury%20corporate%20environment%20warm%20golden%20backlight%20dark%20sophisticated%20ambiance%20premium%20black%20and%20gold%20tones%20leadership%20power&width=600&height=800&seq=mod6-team-gold-01&orientation=portrait",
  },
  {
    id: 7,
    tag: "Bônus",
    name: "Planilhas e Scripts Prontos",
    desc: "Material exclusivo para aplicar imediatamente no seu negócio.",
    icon: "ri-file-list-3-line",
    color: "bg-[#0d1520]",
    accent: "text-white/30",
    isNew: true,
    image: "https://readdy.ai/api/search-image?query=luxury%20golden%20notebook%20planner%20spreadsheet%20on%20elegant%20dark%20marble%20desk%20with%20golden%20pen%20warm%20candlelight%20black%20background%20premium%20stationery%20exclusive%20business%20tools%20sophisticated%20wealthy%20aesthetic&width=600&height=800&seq=mod7-bonus-gold-01&orientation=portrait",
  },
  {
    id: 8,
    tag: "Bônus",
    name: "Presente Surpresa na Inscrição",
    desc: "Ao concluir sua inscrição, você recebe um presente especial da Gleice Lyra.",
    icon: "ri-gift-line",
    color: "bg-[#1a1508]",
    accent: "text-white/30",
    isNew: true,
    image: "https://readdy.ai/api/search-image?query=elegant%20luxury%20gift%20box%20wrapped%20in%20black%20velvet%20ribbon%20golden%20bow%20on%20dark%20background%20warm%20ambient%20golden%20light%20premium%20exclusive%20present%20sophisticated%20wealthy%20black%20and%20gold%20palette%20cinematic%20still%20life&width=600&height=800&seq=mod8-gift-gold-01&orientation=portrait",
  },
];

const filters = ["Todos", "Módulo 1", "Módulo 2", "Módulo 3", "Módulo 4", "Módulo 5", "Módulo 6", "Bônus"];

export default function NewArrivals() {
  const [activeFilter, setActiveFilter] = useState("Todos");

  const filtered =
    activeFilter === "Todos" ? modules : modules.filter((m) => m.tag === activeFilter);

  return (
    <section
      className="py-20 px-6 md:px-16 relative overflow-hidden"
      data-product-shop
      style={{
        backgroundImage: `url("https://readdy.ai/api/search-image?query=elegant%20luxury%20saleswoman%20in%20a%20high-end%20boutique%20store%20wearing%20a%20tailored%20black%20blazer%20with%20gold%20jewelry%20accessories%20standing%20confidently%20surrounded%20by%20warm%20golden%20ambient%20lighting%20dark%20background%20sophisticated%20retail%20environment%20premium%20fashion%20aesthetic%20rich%20warm%20tones%20black%20and%20gold%20palette%20ultra%20detailed%20cinematic&width=1440&height=900&seq=cat-bg-luxury-01&orientation=landscape")`,
        backgroundSize: "cover",
        backgroundPosition: "center top",
      }}
    >
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-black/80 via-black/70 to-black/85 pointer-events-none" />

      <div className="max-w-7xl mx-auto relative z-10">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-10 gap-6">
          <div>
            <p className="text-xs tracking-[0.3em] uppercase mb-2" style={{ color: "#b8962e" }}>Novidades da Semana</p>
            <h2 className="text-3xl font-light tracking-tight text-white max-w-xl">
              Seja uma Especialista no Método CAT e Receba seu Presente ao Final da Inscrição
            </h2>
          </div>
          {/* Filters */}
          <div className="flex flex-wrap items-center gap-1">
            {filters.map((f) => (
              <button
                key={f}
                onClick={() => setActiveFilter(f)}
                className={`whitespace-nowrap px-4 py-2 text-xs tracking-widest uppercase cursor-pointer transition-all border ${
                  activeFilter === f
                    ? "text-black border-[#b8962e] bg-[#b8962e]"
                    : "bg-transparent text-white/70 border-white/30 hover:border-[#b8962e] hover:text-white"
                }`}
              >
                {f}
              </button>
            ))}
          </div>
        </div>

        {/* Modules grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {filtered.map((item) => (
            <div key={item.id} className="group cursor-pointer">
              <div className={`relative w-full aspect-[3/4] ${item.color} overflow-hidden mb-3 flex flex-col items-center justify-center px-6 border border-white/10`}>
                {/* Background image */}
                {item.image && (
                  <img
                    src={item.image}
                    alt={item.name}
                    className="absolute inset-0 w-full h-full object-cover object-top opacity-60 group-hover:opacity-75 transition-opacity duration-500 group-hover:scale-105 transform transition-transform"
                  />
                )}
                {/* Gradient overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-black/20 pointer-events-none" />

                {item.isNew && (
                  <span className="absolute top-3 left-3 text-black text-[10px] tracking-widest uppercase px-2 py-1 font-medium z-10" style={{ backgroundColor: "#b8962e" }}>
                    Incluso
                  </span>
                )}
                <span className="absolute top-3 right-3 text-[10px] tracking-widest uppercase text-white/70 font-light z-10">
                  {item.tag}
                </span>

                {/* Icon */}
                <div className="relative z-10 w-14 h-14 flex items-center justify-center mb-4">
                  <i className={`${item.icon} text-white/60 text-5xl drop-shadow-lg`}></i>
                </div>

                {/* Hover overlay */}
                <div className="absolute inset-x-0 bottom-0 bg-black/70 backdrop-blur-sm text-white text-xs leading-relaxed text-center px-4 py-4 translate-y-full group-hover:translate-y-0 transition-transform duration-300 z-10">
                  {item.desc}
                </div>
              </div>

              {/* Info */}
              <div>
                <p className="text-[11px] tracking-widest uppercase mb-1" style={{ color: "#b8962e" }}>{item.tag}</p>
                <p className="text-sm text-white leading-snug mb-1 font-medium">{item.name}</p>
                <p className="text-xs text-white/50 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <button className="whitespace-nowrap border text-black text-xs tracking-widest uppercase px-12 py-4 transition cursor-pointer" style={{ backgroundColor: "#b8962e", borderColor: "#b8962e" }}>
            Curso Completo
          </button>
        </div>
      </div>
    </section>
  );
}
